import { render, staticRenderFns } from "./UpdateStatusButton.vue?vue&type=template&id=6611c764"
import script from "./UpdateStatusButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateStatusButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports